// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC4i4qA_DJocPHbgueOAQFRhh4Nz8Rnp68",
  authDomain: "quiniela-df1a2.firebaseapp.com",
  projectId: "quiniela-df1a2",
  storageBucket: "quiniela-df1a2.appspot.com",
  messagingSenderId: "970427813072",
  appId: "1:970427813072:web:197c8f72dc99c794a222d5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with app instance
const auth = getAuth();

// Initialize Firestore
const db = getFirestore();

// Configure persistence
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting persistence:", error);
});

// Export auth and firestore instances
export { auth, db };

// Export the app instance
export default app;